import { isTablet } from "react-native-device-info";
import { createPlatformStyles, theme } from "../../../theme/theme";

export const { styles, ids } = createPlatformStyles({
  mobile: {
    container: {
      flex: 1,
      width: "100%",
      alignItems: "center",
    },

    logoContainer: {
      flex: 1,
      alignItems: "center",
      width: "100%",
      justifyContent: "center",
    },

    logo: {
      width: 314,
      height: 240,
      display: "flex",
      marginBottom: "-12%",
      resizeMode: "contain",
      "@media (min-width: 335px)": {
        top: "-10%",
      },
      "@media (min-width: 700px)": {
        top: "-5%",
        width: 620,
        height: 170,
      },
    },

    contentContainer: {
      width: "100%",
      alignItems: "center",
    },
  },

  web: {
    logo: {
      width: "50%",
      maxWidth: 500,
      aspectRatio: 3.5,
      resizeMode: "contain",
      marginBottom: theme.margin.xl,
    },

    container: {
      minHeight: "100vh",
      width: "100%",
      alignItems: "center",
      justifyContent: "space-between",
      overflow: "hidden",
    },

    logoContainer: {
      flex: 1,

      alignItems: "center",
      justifyContent: "center",
      width: "100%",
    },

    contentContainer: {
      position: "fixed",
      bottom: 0,
      width: "100%",
      maxWidth: "100vw",
      alignItems: "center",
      justifyContent: "flex-end",
    },
  },
});
